import {
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

import StyledDialogTitle from "./DialogTitle";
import styles from "./styles";

interface StyledDialogProps {
  title: string | React.ReactElement;
  leftAction?: React.ReactElement;
  rightAction?: React.ReactElement;
  actionContainer?: React.ReactElement | false;
  children: React.ReactNode;
  open: boolean;
  handleClose?: () => void;
  dialogAnnotation?: React.ReactElement;
  centered?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  [rest: string]: any;
}

export default function StyledDialog({
  title,
  leftAction,
  rightAction,
  actionContainer,
  open,
  handleClose,
  children,
  centered = false,
  maxWidth = "md",
  ...rest
}: StyledDialogProps) {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      fullScreen={isMobileScreen}
      maxWidth={maxWidth}
      PaperProps={{
        sx: {
          borderRadius: isMobileScreen ? 0 : 2,
          height: isMobileScreen ? "100%" : "fit-content",
        },
      }}
      {...rest}
    >
      <StyledDialogTitle
        title={title}
        leftAction={leftAction}
        rightAction={rightAction}
        handleClose={handleClose}
        centered={centered}
      />

      <Divider sx={{ bgColor: "purple.light" }} />

      <DialogContent>{children}</DialogContent>
      {actionContainer && (
        <DialogActions sx={styles.footer}>{actionContainer}</DialogActions>
      )}
    </Dialog>
  );
}
